import React, { Component } from 'react'
import { post } from '../../../utils/networking'
import $ from 'jquery'
import './style.css'

export default class Tree extends Component {


    renderTree = (node, i) => {
        if (node.children == null)
            return <div className="leaf" key={i} style={{ paddingLeft: '40px', borderLeft: "3px solid #f0f0f0", marginLeft: "10px" }} >
                <div className="avatar">
                    <img src={require('../../../assets/images/girl.png')} />
                </div>
                <div className="info">
                    <span className="referral_ID">{node.id}</span>
                    <span className="email">{node.email}</span>
                </div>
            </div>
        return <div className="node" style={{ paddingLeft: '40px', borderLeft: "3px solid #f0f0f0", marginLeft: "10px" }} key={i}>
            <div className="node-info">
                <div className="avatar">
                    <img src={require('../../../assets/images/girl.png')} />
                </div>
                <div className="info">
                    <span className="referral_ID">{node.id}</span>
                    <span className="email">{node.email}</span>
                </div>
            </div>
            <div className="children" style={{ paddingLeft: '10px' }}>
                {
                    node.children.map((child) => this.renderTree(child, ++i))
                }
            </div>
        </div>

    }


    render() {

        var root = this.props.root

        var tree = this.renderTree(root, 0)

        return tree
    }
}


// WEBPACK FOOTER //
// ./src/components/user/tree/index.js